export default "__VITE_ASSET__BXky1dAj__"